import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import { ElConfigProvider } from 'element-plus';
import 'element-plus/es/components/config-provider/style/css'

// 导入 Element Plus 语言包
import global from './component-create/utils/global';
import { LOADERS } from './constant/select-loader/index';
import request from '@/utils/request';
import { solveResizeObserverLoopLimitExceededErr } from './utils/common';
import { GLOBAL_DATA } from '@/component-create/utils/global-enum';
import AppConfig from '@/settings.js';
import { getLangByLocale } from './component-create/utils/elemen-ui-utils';
import * as dictApi from '@/api/system/dictionary-data';
import { download } from './utils/http';
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {
    const locale = getLangByLocale(AppConfig.locale);
    solveResizeObserverLoopLimitExceededErr();
    const TABLE_REQUEST = (url, data) => {
      return request({
        url: url,
        method: 'get',
        params: data
      });
    };
    const FORM_REQUEST_SAVE = (url, data, method = 'post') => {
      return request({
        url: url,
        method: method,
        data: data
      });
    };
    const FORM_REQUEST_LOAD = (url, data) => {
      return request({
        url: url + '/' + data,
        method: 'get'
      });
    };
    const TREE_REQUEST = (url, data) => {
      return request({
        url: url,
        method: 'get',
        params: data
      });
    };
    const SELECT_REQUEST = code => {
      return dictApi.listByDictCode(code);
    };
    global.provide(GLOBAL_DATA.LOADERS, LOADERS);
    global.provide(GLOBAL_DATA.SELECT_REQUEST, SELECT_REQUEST);
    global.provide(GLOBAL_DATA.TABLE_REQUEST, TABLE_REQUEST);
    global.provide(GLOBAL_DATA.FORM_REQUEST_SAVE, FORM_REQUEST_SAVE);
    global.provide(GLOBAL_DATA.FORM_REQUEST_LOAD, FORM_REQUEST_LOAD);
    global.provide(GLOBAL_DATA.TREE_REQUEST, TREE_REQUEST);
    global.provide(GLOBAL_DATA.FILE_DOWNLOAD, download);
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_unref(ElConfigProvider), {
        locale: _unref(locale)
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view, null, {
          default: _withCtx(({
            Component,
            route
          }) => [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            ":key": route.fullPath
          }, null, 8, [":key"]))], 1024))]),
          _: 1
        })]),
        _: 1
      }, 8, ["locale"]);
    };
  }
});